import { render, staticRenderFns } from "./AccommodationsReview.vue?vue&type=template&id=c4e15fbc&scoped=true&"
import script from "./AccommodationsReview.vue?vue&type=script&lang=js&"
export * from "./AccommodationsReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e15fbc",
  null
  
)

export default component.exports